import usStateCodes from 'shared_src/dictionaries/usStateCodes'

export default usStateCodes
